// Import all views here
import templateHome from './views/template-home';
import templateProjects from './views/template-projects';
import singleProject from './views/single-project';
import templateAbout from './views/template-about';

export default [templateHome, templateProjects, singleProject, templateAbout];
